import BaseResource from './BaseResource';

export interface LineData {
  text: string;
  translation?: string;
  participantId: string;
  participantName?: string;
  participantRole?: string;
  participantAvatar?: string;
  audioTrack?: string;
  audio?: string;
  audioRange?: {
    start: number;
    end: number;
  };
}

export interface ScenarioData {
  id: string;
  title: string;
  description: string;
  summary?: string;
  environmentTitle?: string;
  lines?: LineData[];
  audioTrack?: string;
  missions?: any;
  dialogueAnalysis?: any;
  pastChatIds?: string[];
}

export interface CreateScenarioFormData {
  title: string;
  description: string;
  lines: LineData[];
}

class ScenarioResource extends BaseResource<ScenarioData> {
  static get storeName(): string {
    return 'ScenarioResource';
  }

  static get endpoint(): string {
    return `/coach/scenarios`;
  }

  static toObject(raw: any): ScenarioResource {
    raw.lines = raw.lines?.map((line: any) => ({
      ...line,
      participantId: line.participant?.id ?? line.participantId ?? undefined,
      audio: `${this.apiRoot}${this.endpoint}/${raw.id}/lines/${line.id}/audio`,
    }));
    return new ScenarioResource(raw as ScenarioData);
  }
}

export default ScenarioResource;
